import React, { useState } from 'react';
import { MenuItem, Box } from '@mui/material';
import { IoStatsChartOutline } from "react-icons/io5";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SymbolDetailsModal from '../modal/SymbolDetailsModal';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { MdOutlineDisabledVisible } from "react-icons/md";
import { IoIosAddCircleOutline } from "react-icons/io";
import { MdOutlineHideSource } from "react-icons/md";
import { HiOutlineWindow } from "react-icons/hi2";

const MenuComponent = ({ closeMenu, onOpenTradeModal, darkMode, onChartClick, onHideSymbol, handleOpenNewDashboard, selectedRow, showNewDashboardOption = true, onHideAllSymbols, onShowAllSymbols }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation()
  const { globalSymbolID } = useSelector(state => state.globalSymbol)
  const { userDetail } = useSelector(state => state.user);
  const id = userDetail?.id;

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    closeMenu()
  };

  const handleHideSymbol = () => {
    const symbolIdToHide = selectedRow?.id || globalSymbolID;
    const storedHiddenSymbols = JSON.parse(localStorage.getItem(`hiddenSymbols_${id}`)) || [];
    if (symbolIdToHide) {
      const updatedHiddenSymbols = new Set(storedHiddenSymbols);
      updatedHiddenSymbols.add(Number(symbolIdToHide));
      localStorage.setItem(
        `hiddenSymbols_${id}`,
        JSON.stringify(Array.from(updatedHiddenSymbols).filter(Boolean))
      );
    }
    closeMenu();
  };

  return (
    <>
      <Box p={0.8} sx={{ backgroundColor: darkMode ? "#273649" : 'var(--white)' }}>
        {showNewDashboardOption && (<MenuItem onClick={handleOpenNewDashboard} sx={{ fontSize: 14 }}> <HiOutlineWindow style={{ marginRight: 4, fontSize: 18 }} />{t('popupTrade')}</MenuItem>)}
        <MenuItem onClick={() => { onOpenTradeModal(); closeMenu(); }} sx={{ fontSize: 14 }}> <IoIosAddCircleOutline style={{ marginRight: 4, fontSize: 18 }} />{t('newOrder')}</MenuItem>
        <MenuItem onClick={() => { onChartClick(); closeMenu(); }} sx={{ fontSize: 14 }}><IoStatsChartOutline style={{ marginRight: 4, fontSize: 18 }} />{t('chart')}</MenuItem>
        <MenuItem onClick={handleHideSymbol} sx={{ fontSize: 14 }}> <TaskAltIcon sx={{ mr: 0.8, fontSize: 16 }} />{t('hide')}</MenuItem>
        <MenuItem onClick={() => { onHideAllSymbols(); closeMenu(); }} sx={{ fontSize: 14 }}><MdOutlineHideSource style={{ marginRight: 5, fontSize: 16 }} />{t('hideAll')}</MenuItem>
        <MenuItem onClick={() => { onShowAllSymbols(); closeMenu(); }} sx={{ fontSize: 14 }}><MdOutlineDisabledVisible style={{ marginRight: 5, fontSize: 16 }} />{t('showAll')}</MenuItem >
        <MenuItem onClick={openModal} sx={{ fontSize: 14 }}> <InfoOutlinedIcon sx={{ mr: 0.8, fontSize: 16 }} />{t('symbolDetails')} </MenuItem>
      </Box >
      {isModalOpen && (<SymbolDetailsModal open={isModalOpen} closeModal={closeModal} />)}

    </>
  );
};

export default MenuComponent; 